














import { Component } from 'vue-property-decorator';

import SignUpService from '@/api/SingupService';

import BusinessDetailsForm from '@/componentsV2/templates/BusinessDetailsForm/BusinessDetailsForm.vue';

import InternationalizationService from '@/api/InternationalizationService';
import { scrollToTop } from '@/utils/scrollToTop';
import { OnboardingURL } from '@/views/Onboarding/helpers';
import BusinessOnboardingModel from '../../../BusinessOnboardingModel.vue';

@Component({
  components: {
    BusinessDetailsForm
  }
})
export default class StoreDetails extends BusinessOnboardingModel {
  signUpService: SignUpService = new SignUpService();
  internationalizationService = new InternationalizationService();

  get yourStoreFormData() {
    return this.$store.getters['businessOnboarding/getYourStoreForm'];
  }

  get defaultFormData() {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm'];
  }

  get needsToComplete() {
    return this.$route.path.includes('complete');
  }

  mounted() {
    scrollToTop('bo-base-layout__right');
  }

  async onSubmit(formData: Record<string, any>) {
    this.$store.dispatch('businessOnboarding/SET_STORE_DETAILS_FORM', formData);
    this.saveBusinessLead();

    this.$router.push(OnboardingURL.AI_BUSINESS_PREVIEW);
  }

  back() {
    if (this.needsToComplete) {
      document.location.href = 'https://www.twism.com';
      return;
    }
    this.$router.push(OnboardingURL.AI_BUSINESS_PREVIEW);
  }
}
